module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/ian_headshot_smile-b903fb205b52f0700ed096f73d3e7ab2.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/ian_headshot_smile.png
// module id = 2444
// module chunks = 2